import { PARTNER_USER_ACTION } from '../../models';

export interface PartnerUserActionConfig {
  action: PARTNER_USER_ACTION;
  icon: string;
  text: string;
}

export const PARTNER_USER_ACTIONS: PartnerUserActionConfig[] = [
  { action: PARTNER_USER_ACTION.EDIT, icon: 'remix:Design/edit-line', text: 'partners.users.actions.edit' },
  {
    action: PARTNER_USER_ACTION.CHANGE_ROLE,
    icon: 'remix:System/shield-user-line',
    text: 'partners.users.actions.change-role',
  },
  {
    action: PARTNER_USER_ACTION.SET_PASSWORD,
    icon: 'remix:System/lock-password-line',
    text: 'partners.users.actions.set-password',
  },
  { action: PARTNER_USER_ACTION.DELETE, icon: 'remix:System/delete-bin-line', text: 'partners.users.actions.delete' },
];

export const OWN_PARTNER_USER_ACTIONS = PARTNER_USER_ACTIONS.filter(
  ({ action }) => action !== PARTNER_USER_ACTION.SET_PASSWORD
);

export const SIGNED_IN_USER_ACTIONS = PARTNER_USER_ACTIONS.filter(({ action }) => action === PARTNER_USER_ACTION.EDIT);
